import { redirect } from 'react-router';

import { MUST_CHANGE_PASSWORD_CLAIM } from '@virtual-care/isomorphic';

import { auth, getIdentity } from './firebase.tsx';

export async function requiresAuth() {
  const identity = await getIdentity();
  if (!identity) {
    throw redirect('/signin');
  }

  const user = auth.currentUser;
  if (user) {
    const tokenResult = await user.getIdTokenResult();
    const mustChange = Boolean(tokenResult.claims[MUST_CHANGE_PASSWORD_CLAIM]);
    if (mustChange && window.location.pathname !== '/change-password') {
      throw redirect('/change-password');
    }
  }

  if (identity.userType === 'B2C' && !identity.b2cProfile) {
    throw redirect('/complete');
  }
  return identity;
}
